import {
  queryLotteryList,
  queryPlayLayoutByBettingId,
  getLotteryDetailV2,
  betting,
  queryPrizeHistoryListV2,
  queryChatPrizeList,
  queryPrizeRankingList,
  queryLotteryPlayList,
  queryLotteryTypeRuleList,
  queryPrizeList,
  queryLotteryRecordListV2,
  queryLotteryRecordList,
  dragon
} from "@/api/lottery";
import {
  SET_LOTTERY_AllLOTTEY_SWITCH,
  SET_LOTTERY_RECORD_LIST,
  SET_LOTTERY_INFO
} from "@/store/mutation_types";

const lottery = {
  state: {
    allLotteySwitch: false,
    lotteryRecordList: {},
    lotteryInfo: {},
    dragonInfo: {}
  },
  getters: {
    lotteryAllLotteySwitch: state => state.allLotteySwitch,
    lotteryRecordList: state => state.lotteryRecordList,
    dragonInfo: state => state.dragonInfo
  },
  mutations: {
    [SET_LOTTERY_AllLOTTEY_SWITCH]: (state, data) => {
      state.allLotteySwitch = data;
    },
    [SET_LOTTERY_RECORD_LIST]: (state, data) => {
      state.lotteryRecordList = data;
    },
    [SET_LOTTERY_INFO]: (state, data) => {
      state.lotteryInfo = data;
    }
  },
  actions: {
    // 11.购彩彩票列表接口
    async queryLotteryList({ commit }, playload) {
      const { data, config } = playload;
      const res = await queryLotteryList(data, config);
      return res;
    },
    async dragon({ commit }, playload) {
      const { data, config } = playload;
      const res = await dragon(data, config);
      return res;
    },
    async queryPlayLayoutByBettingId({ commit }, playload) {
      const { data, config } = playload;
      const res = await queryPlayLayoutByBettingId(data, config);
      const ret = res.data.data;
      return res;
    },
    async getLotteryDetailV2({ commit, display }, playload = {}) {
      const { data, config } = playload;
      const res = await getLotteryDetailV2(data, config);
      const ret = res.data.data;
      return res;
    },
    //聊天室投注
    async lotteryBetting({ commit }, playload) {
      const { data, config } = playload;
      // console.log("data")
      // console.table(data);
      const res = await betting(data, config);
      const ret = res.data.data;
      if (res.data.code == 0) {
        commit("SET_USER_KEY_VAL", {
          balance: ret
        });
      }
      return res;
    },
    async queryPrizeHistoryListV2({ commit }, playload) {
      const { data, config } = playload;
      const res = await queryPrizeHistoryListV2(data, config);
      const ret = res.data.data;
      return res;
    },
    async queryChatPrizeList({ commit }, playload) {
      const res = await queryChatPrizeList(playload);
      return res;
    },
    async queryPrizeRankingList({ commit }, playload) {
      const res = await queryPrizeRankingList(playload);
      return res;
    },
    async queryLotteryPlayList({ commit }, playload) {
      const { data, config } = playload;
      const res = await queryLotteryPlayList(data, config);
      const ret = res.data.data;
      return res;
    },
    async queryLotteryTypeRuleList({ commit }, playload) {
      const { data, config } = playload;
      const res = await queryLotteryTypeRuleList(data, config);
      const ret = res.data.data;
      return res;
    },
    async queryLotteryPrizeList({ commit }, playload) {
      const { data, config } = playload;
      const res = await queryPrizeList(data, config);
      const ret = res.data.data;
      return res;
    },
    async downTimeQueryLotteryRecordList({ commit }, playload) {
      const { data, isV2, config = {} } = playload;
      if (isV2) {
        const res = await queryLotteryRecordListV2(data, config);
        const ret = res.data.data;
        commit(SET_LOTTERY_RECORD_LIST, ret);
        return res;
      }
      return await queryLotteryRecordList(data, config);
    }
  }
};

export default lottery;
